import icon1 from '../../../Assets/icon_card_wiseprevent_1.png'
import icon2 from '../../../Assets/icon_card_wiseprevent_2.png'
import icon3 from '../../../Assets/icon_card_wiseprevent_3.png'
import icon4 from '../../../Assets/icon_card_wiseprevent_4.png'
import icon5 from '../../../Assets/icon_card_wiseprevent_5.png'
import icon6 from '../../../Assets/icon_card_wiseprevent_6.png'
import logo from '../../../Assets/bindtrack_logo2.png'
import img1 from '../../../Assets/Track_Imagem_1.png'
import img2 from '../../../Assets/Track_Imagem_2.png'
import { HeroSection } from '../Components/HeroSection'
import { CardSection } from '../Components/CardSection'
import { ValueSection } from '../Components/ValueSection'
import { FaqSection } from '../Components/FaqSection'

const CARDS = [
  {
    icon: icon1,
    title: "Rastreamento em Tempo Real",
    text: "Acompanhe cada veículo e carga com dados de telemetria.",
  },
  {
    icon: icon2,
    title: "Gestão de Pátio",
    text: "Controle o fluxo de entrada e saída de veículos e otimize o tempo de espera.",
  },
  {
    icon: icon3,
    title: "Alertas Inteligentes",
    text: "Receba notificações automáticas sobre desvios de rota ou paradas não programadas.",
  },
  {
    icon: icon4,
    title: "ashboard de Performance",
    text: "Visualize indicadores de eficiência e KPIs logísticos.",
  },
  {
    icon: icon5,
    title: "Integração com ERPs",
    text: "Conecte sua operação a sistemas de gestão e controle corporativo.",
  },
  {
    icon: icon6,
    title: "Gestão de Entregas e Ocorrências",
    text: "Registre e acompanhe entregas, desvios e incidentes logísticos com alertas inteligentes e relatórios.",
  },
];

const BLOCKS = [
  {
    title: "Resultados que vão além da operação",
    text:
      `Operações mais eficientes e rastreáveis, com redução de perdas e otimização de recursos.`,
    bullets: [
      {
        title: "Visibilidade total da cadeia de transporte.",
        text: ""
      },
      {
        title: "Eficiência e segurança em tempo real.",
        text: ""
      },
      {
        title: "Redução de custos logísticos.",
        text: ""
      },
    ],
    img: img2,
  },
];

const FAQ = [
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'Aliquam sit amet odio faucibus, sodales metus placerat, pharetra tortor. Donec ornare urna et tellus rhoncus gravida. Mauris efficitur purus sed ipsum pretium aliquet.'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
]
export const Bindtrack = () => {
  return (
    <div>
      <HeroSection
        logo={logo}
        title='IoT e inteligência em movimento para operações logísticas mais seguras e eficientes.'
        text='A BindTrack fornece rastreabilidade e controle logístico total para frotas, cargas e pátios.'
        colorBtn='--color-2a73ff'
        url='https://bindtrack.com.br/'
        img={img1}
      />

      <CardSection
        cards={CARDS}
        title='Controle e visibilidade em tempo real sobre toda a cadeia logística.'
        text='Com a BindTrack, sua operação ganha eficiência, reduz custos e aumenta a previsibilidade das entregas.
'
      />

      <ValueSection
        blocks={BLOCKS}
      />

      {/* <FaqSection
        title="Suas principais dúvidas, respondidas"
        text={[
          'Com a WisePrevent, você reduz custos, prolonga a vida útil dos ativos e tem total controle do que foi feito, por quem e quando.',
          'Tudo rastreável, auditável e pronto para apresentar à gestão ou aos órgãos reguladores.'
        ]}
        colorBtn='--color-ff7022'
        faq={FAQ}
      /> */}

    </div>
  )
}
